import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/media/video-gallery/components/VideoGalleryView.tsx");
